import { login } from "./auth/login";
import { editClaimVoidStatusById } from "./paidClaims/editClaimVoidStatus";
import { updateClaimCategoryByIdList } from "./paidClaims/updateClaimCategory";
import { getPaidClaims, getAllPaidClaimList } from "./paidClaims/getPaidClaims";
import { countPaidClaims } from "./paidClaims/countPaidClaims";
import { updateGroupOwnerSettings } from "./settings/updateSettings";
import { getGroupOwnerSettings } from "./settings/getSettings";
import { editClaimStatusById } from "./paidClaims/editClaimStatus";
import { findDuplicateClaimBuClaimNumber } from "./paidClaims/validateDuplicateClaim";
import { deleteNote, getNotes, postNote, updateNote } from "./notes/notes";
import { getAppealPaidClaims } from "./paidClaims/getAppealPaidClaims";
import { getIDRTrackers } from "./paidClaims/getIDRTrackerPaidClaims";
import { addIDRTracker, editIDRTracker } from "./paidClaims/addIDRTracker";

export const api = {
	auth: {
		login
	},
	paidClaim: {
		editClaimVoidStatusById,
		updateClaimCategoryByIdList,
		getAllPaidClaimList,
		getPaidClaims,
		countPaidClaims,
		editClaimStatusById,
		findDuplicateClaimBuClaimNumber,
		getAppealPaidClaims,
		addIDRTracker,
		editIDRTracker,
		getIDRTrackers
	},
	settings: {
		updateGroupOwnerSettings: updateGroupOwnerSettings,
		getGroupOwnerSettings: getGroupOwnerSettings
	},
	notes: {
		getNotes: getNotes,
		postNote: postNote,
		updateNote: updateNote,
		deleteNote: deleteNote
	}
};
